import React from 'react';
import styled from 'styled-components';
import Visitor from '../../components/layouts/Visitor';
import HeaderOne from '../../components/parts/HeaderOne';
import AccountActivationForm from '../../components/combinations/AccountActivationForm';
import LinkText from '../../components/parts/LinkText';
import UserHead from "../../config/UserHead";

const AccountActivationStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const ToLoginPageStyle = styled(LinkText)`
  text-align: center;
  text-decoration: underline;
`;

const AccountActivation: React.FC = (() => {

  return (
    <Visitor>
      <UserHead title='アカウントの有効化' />
      <AccountActivationStyle>
        <HeaderOneStyle>アカウントの有効化</HeaderOneStyle>
        <AccountActivationForm />
        <ToLoginPageStyle href='/user/login'>ログインページ</ToLoginPageStyle>
      </AccountActivationStyle>
    </Visitor>
  );
});
export default AccountActivation;
